import { BoxProps } from "@mui/material";
import React from "react";

import { BrandCodeEnum } from "src/graphql/generated/types";

import { LegalInfo as EssetLegalInfo } from "./esset";
// eslint-disable-next-line no-restricted-syntax
import { LegalInfo as FonciaLegalInfo } from "./foncia";

type Props = { brandCode: BrandCodeEnum } & BoxProps;

const components: Record<BrandCodeEnum, React.ComponentType> = {
  [BrandCodeEnum.Foncia]: FonciaLegalInfo,
  [BrandCodeEnum.Esset]: EssetLegalInfo,
};

export const LegalInfo = ({ brandCode, ...boxProps }: Props) => {
  const Component = components[brandCode];

  return <Component {...boxProps} />;
};
